/** Shared growth-hook copy (#23). */
export const HAVE_A_BUSINESS_COPY =
  "Have a business? Get customers referred to you — add it free";

export const ADD_BUSINESS_PATH = "/app/add-business";

export const SHARE_TAGLINE =
  "referlinc.com — refer businesses you trust, earn rewards";

/** Keep share messages short: one pitch line + one tagline line. */
export function referralShareMessage(companyName, url, { greeting } = {}) {
  const pitch = greeting
    ? `Hey ${greeting}, check out ${companyName} on ReferLinc: ${url}`
    : `Check out ${companyName} on ReferLinc — I think you'll love them: ${url}`;
  return `${pitch}\n${SHARE_TAGLINE}`;
}

export function whatsappShareMessage(companyName, url) {
  return `Check out ${companyName} on ReferLinc: ${url}\n${SHARE_TAGLINE}`;
}
